module.exports = __webpack_public_path__ + "static/media/about18.af4d6f6d.webp";